import styled, { css } from "styled-components";

export const ColorDisplayWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	position: relative;
`;

export const ProductAttrItem = styled.span`
	margin-right: 7px;
	padding: 0;
	line-height: 0;
	border: 1px solid #fff;
	width: 18px;
	height: 18px;
	display: inline-block;
	position: relative;
	&:hover {
		border-radius: 2px;
		border: 1px solid #cb2027;
	}
	${(props: { isMore?: boolean }) => {
		if (props.isMore) {
			return css`
				margin-right: 0;
			`;
		}
	}}
	::after {
		position: absolute;
		top: 0;
		left: 0;
		content: "";
		background: rgba(0, 0, 0, 0.03);
		width: 100%;
		height: 100%;
	}
`;

export const ProductAttrItemImg = styled.img`
	width: 18px;
	height: 18px;
	border-radius: 2px;
	display: inline-block;
`;

export const ColorsWrap = styled.div`
	position: absolute;
	z-index: 2;
	right: 0;
	width: 214px;
	max-width: 214px;
	visibility: hidden;
	opacity: 0;
	/* opacity: 1;
    visibility: visible; */
	padding: 12px;
	text-align: left;
	background: #fff;
	border: 1px solid #dedede;
	border-radius: 4px;
	-webkit-box-shadow: 0 1px 8px rgb(0 0 0 / 10%);
	-moz-box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
	box-shadow: 0 1px 8px rgb(0 0 0 / 10%);
`;

export const Triangle = styled.div`
	position: absolute;
	top: -9px;
	right: 6px;
	margin-left: -8px;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-bottom: 10px solid #fff;
	border-right: 10px solid transparent;
	z-index: 1;
`;

export const TriangleBg = styled.div`
	top: -11px;
	right: 6px;
	border-left: 10px solid transparent;
	border-bottom: 10px solid #ddd;
	border-right: 10px solid transparent;
	z-index: 0;
	margin-left: -8px;
	width: 0;
	height: 0;
	position: absolute;
`;

export const OmitWrap = styled.span`
	height: 18px;
	color: #333;
	&:hover {
		> svg {
			color: #e33124;
		}
	}
	&:hover ${ColorsWrap} {
		opacity: 1;
		visibility: visible;
	}
`;

export const ColorList = styled.div`
	display: flex;
	flex-wrap: wrap;
	grid-gap: 9px 7px;
`;
